import { NotifyError, NotifySuccess } from "../Notify/notify";

const BASE = () => process.env.REACT_APP_API_BASE_URL + '/torkorders';
const authHeader = (jwtToken) => ({ Authorization: `Bearer ${jwtToken}` });
const jsonHeader = (jwtToken) => ({ "Content-Type": "application/json", ...authHeader(jwtToken) });

export const GetActiveOrders = (jwtToken, callback) => {
    fetch(BASE(), { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta torkordrar."));
}

export const GetAllOrders = (jwtToken, callback) => {
    fetch(BASE() + '/all', { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta orderhistorik."));
}

export const GetOrdersByOrderId = (orderId, jwtToken, callback) => {
    fetch(BASE() + '/order/' + encodeURIComponent(orderId), { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta order."));
}

export const CreateOrders = (payload, jwtToken, callback) => {
    return fetch(BASE(), {
        method: "POST",
        body: JSON.stringify(payload),
        headers: jsonHeader(jwtToken)
    })
        .then(async res => {
            if (res.status >= 300) throw new Error(await res.text());
            return res.json();
        })
        .then(res => {
            NotifySuccess("Order skapad!");
            callback(res.orders, res.hasActiveNotes);
        })
        .catch(() => NotifyError("Kunde inte skapa order."));
}

export const UpdateOrder = (order, jwtToken, callback) => {
    fetch(BASE(), {
        method: "PUT",
        body: JSON.stringify(order),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Order uppdaterad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte uppdatera order."));
}

export const StartTork = (id, payload, jwtToken, callback) => {
    fetch(BASE() + '/' + id + '/start', {
        method: "POST",
        body: JSON.stringify(payload),
        headers: jsonHeader(jwtToken)
    })
        .then(async res => {
            if (res.status >= 300) throw new Error(await res.text());
            return res.json();
        })
        .then(res => {
            NotifySuccess("Tork startad!");
            callback(res);
        })
        .catch((e) => NotifyError(e.message || "Kunde inte starta tork."));
}

export const ChangeOrderStatus = (id, status, comment, jwtToken, callback) => {
    fetch(BASE() + '/' + id + '/status', {
        method: "POST",
        body: JSON.stringify({ status, comment }),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte ändra status."));
}

export const SampleOrder = (id, comment, jwtToken, callback) => {
    fetch(BASE() + '/' + id + '/sample', {
        method: "POST",
        body: JSON.stringify({ comment }),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Prov registrerat!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte registrera prov."));
}

export const DeleteOrder = (id, jwtToken, callback) => {
    fetch(BASE() + '/' + id, {
        method: "DELETE",
        headers: authHeader(jwtToken)
    })
        .then(res => res.json())
        .then(() => {
            NotifySuccess("Order borttagen!");
            callback();
        })
        .catch(() => NotifyError("Kunde inte ta bort order."));
}

export const BulkUpdatePrios = (prios, jwtToken, callback, onError) => {
    fetch(BASE() + '/prios', {
        method: "PUT",
        body: JSON.stringify({ items: prios }),
        headers: jsonHeader(jwtToken)
    })
        .then(async res => {
            if (res.status >= 300) throw new Error(await res.text());
            return res.json();
        })
        .then(res => callback(res))
        .catch(() => {
            NotifyError("Kunde inte uppdatera prioriteter.");
            if (onError) onError();
        });
}
